import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Inbox, LogIn } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back");
      navigate("/dashboard");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Login failed";
      toast.error(msg);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-md bg-[#002FA7] flex items-center justify-center">
            <Inbox size={20} className="text-white" strokeWidth={2.5} />
          </div>
          <div>
            <div
              className="text-xl font-semibold text-[#0F172A] tracking-tight"
              style={{ fontFamily: "Outfit" }}
            >
              Inbox Marketing
            </div>
            <div className="text-[11px] uppercase tracking-wider text-[#94A3B8] font-medium">
              Owner Access
            </div>
          </div>
        </div>

        <div className="bg-white border border-[#E2E8F0] rounded-xl p-8 shadow-sm">
          <h1
            className="text-2xl font-semibold text-[#0F172A] tracking-tight mb-1"
            style={{ fontFamily: "Outfit" }}
          >
            Sign in
          </h1>
          <p className="text-sm text-[#475569] mb-6">
            Enter your credentials to access the dashboard.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[#0F172A] mb-1.5">Email</label>
              <input
                type="email"
                required
                className="field-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                data-testid="input-login-email"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[#0F172A] mb-1.5">Password</label>
              <input
                type="password"
                required
                className="field-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                data-testid="input-login-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full inline-flex items-center justify-center gap-2 mt-6"
              data-testid="btn-login-submit"
            >
              <LogIn size={14} />
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>

        <p className="text-center text-xs text-[#94A3B8] mt-6">
          Private system — access restricted to the owner.
        </p>
      </div>
    </div>
  );
}
